import type { ComputedRef, Ref } from 'vue';
import { unref } from 'vue';
import { useShipmentFormStore } from '@/stores/useShipmentFormStore';

type PersistMetadataDeps = {
  patchShipment: (args: {
    accountId: number;
    shipmentId: number;
    payload: {
      name: string;
      carrier: string | null;
      notes: string | null;
      asset_value: number | null;
    };
  }) => Promise<unknown>;
};

export async function persistFormMetadata(
  deps: PersistMetadataDeps,
  options: {
    accountId: Ref<number> | ComputedRef<number>;
    shipmentId: Ref<number | null> | ComputedRef<number | null>;
  },
  payload: {
    name: string;
    carrier: string | null;
    notes: string | null;
    asset_value: number | null;
  },
) {
  const sid = unref(options.shipmentId);
  if (sid == null) {
    throw new Error('Missing shipment id');
  }

  await deps.patchShipment({
    accountId: unref(options.accountId),
    shipmentId: sid,
    payload,
  });

  const formStore = useShipmentFormStore();
  formStore.markMetadataPersisted(
    payload.name,
    payload.carrier,
    payload.notes,
    payload.asset_value,
  );
}
